<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="pa-2">
        <ListOptionsOverview></ListOptionsOverview>
      </v-col>
      <v-col>
        <GraphOptionsPerWeek cols="12" md="6" class="pa-2"></GraphOptionsPerWeek>
      </v-col>
    </v-row>
    <v-row> </v-row>
  </div>
</template>

<script>
import GraphOptionsPerWeek from "./GraphOptionsPerWeek.vue";
import ListOptionsOverview from "./ListOptionsOverview.vue";

export default {
  components: { GraphOptionsPerWeek, ListOptionsOverview },
};
</script>

<style lang="scss" scoped>
</style>